// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"5348808d","118":"33e3873b","148":"509dc627","174":"71015e2a","412":"71015e2a","511":"71015e2a","837":"5348808d","892":"5348808d","912":"5348808d","966":"33e3873b"}[chunkId] + ".chunk.css";
};